module.exports = __webpack_public_path__ + "static/media/arrow-down.aa0f0475.svg";